var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "square",
    attrs: {
      "aria-label": ("Number " + (_vm.number))
    }
  }, [!_vm.isUnit ? _c('div', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "stringSpan"
  }, [_vm._v(_vm._s(_vm.convertedNumber))])]) : _c('div', {
    attrs: {
      "aria-hidden": "true"
    }
  }, _vm._l(_vm.units, function (unit) {
    return _c('div', {
      key: ("square" + (unit.value)),
      class: ['unit', {
        hidden: unit.hidden
      }],
      attrs: {
        "track-by": "$index"
      }
    });
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }